<template>
  <div class="login-confirm-custom-class">
    <h1 style="display: flex;">
      <i class="el-icon-warning" style="color: #E6A23C;font-size: 22px; line-height: 30px;"></i>
      <div style="display: inline-block;height: 30px;font-size: 12px;line-height: 30px;">{{ title }}</div>
    </h1>
    <div class="login-confirm-custom-body">
      <div v-if="isOnlineSupport">请复制授权码到
        <a href="http://osp.cnetong.com" target="_blank">企业服务平台</a>
        {{ suffix }}
      </div>
      <div v-else>请复制授权码联系相关人员{{suffix}}
      </div>
      <div class="auth">
        <span class="label">授权码</span>
        <span class="code">{{ authCode || realtimeAuthCode }}</span>
        <i class="el-icon-copy-document" id="login-clock-copy" title="复制授权码" @click="copy" v-if="authCode"></i>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderApi from '../header/Header';
export default {
  props: {
    code: String,
    authCode: String,
  },
  components: {},
  data() {
    return {
      isOnlineSupport: false,
      title: '',
      prefix: '',
      suffix: '',
    }
  },
  watch() {
  },
  mounted() {
    this.init();
  },
  created: function () {
    HeaderApi.isOnlineSupport().then(resp=>{
      this.isOnlineSupport = resp.isOnlineSupport;
    })

  },
  methods: {
    init() {
      switch (this.code) {
        case "6":
          this.title = '客户端授权不存在';
          // this.prefix = '请复制授权码到';
          this.suffix = '申请授权';
          break;
        case "7":
          this.title = '客户端授权申请未审批';
          // this.prefix = '请复制授权码到';
          this.suffix = '查看审批进度';
          break;
        case "8":
          this.title = '客户端授权申请未通过';
          // this.prefix = '请复制授权码到';
          this.suffix = '申请授权';
          break;
        case "9":
          this.title = '客户端授权变更申请未审批';
          // this.prefix = '请复制授权码到';
          this.suffix = '查看审批进度';
          break;
        case "10":
          this.title = '客户端授权变更申请未通过';
          // this.prefix = '请复制授权码到';
          this.suffix = '申请授权';
          break;
        case "11":
          this.title = '客户端授权已超期';
          // this.prefix = '请复制授权码到';
          this.suffix = '申请授权';
          break;
        case "12":
          this.title = '客户端授权延期申请未审批';
          // this.prefix = '请复制授权码到';
          this.suffix = '查看审批进度';
          break;
        case "13":
          this.title = '客户端授权延期申请未通过';
          // this.prefix = '请复制授权码到';
          this.suffix = '申请授权';
          break;
        case "14":
          this.title = '客户端授权已禁用';
          // this.prefix = '请复制授权码到';
          this.suffix = '反馈问题';
          break;
        default:
          this.title = '客户端授权异常';
          // this.prefix = '请复制授权码到';
          this.suffix = '反馈问题';
      }
    },
    copy() {
      let aux = document.createElement("input");
      aux.setAttribute("value", this.authCode);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message.success("复制成功")
    }
  }
}
</script>
<style scoped lang="scss">
.login-confirm-custom-class {
  padding: 0;
  width: auto;
  font-size: 12px !important;

  a:link,
  a:visited,
  a:active,
  {
    color: #409EFF;
  }

  a:hover {
    color: #1189ff;
  }

  h1 {
    height: 30px;
    margin: 0;
    padding-left: 15px;
    padding-bottom: 5px;
    padding-top: 5px;
    border-bottom: 1px solid #ccc;

    i {
      margin-right: 10px;
    }

  }

  .login-confirm-custom-body {

    div {
      margin: 15px;
    }

    .auth {
      border: 0.5px solid #adacac;
      border-radius: 30px;

      .label {
        display: inline-block;
        background-color: #3598dc;
        color: #fff;
        border-radius: 30px;
        width: 70px;
        text-align: center;
      }

      .code {
        margin-left: 5px;
      }

      .el-icon-copy-document {
        cursor: pointer;
        display: inline-block;
        width: 30px;
        text-align: center;
        float: right;
        line-height: 16px;

        &:hover {
          color: #3598dc;
        }

      }
    }
  }
}
</style>